import { Paper, Stack, Typography } from "@mui/material";

type ChartCardProps = {
  title: string;
};

export default function ChartCard({
  children,
  title,
}: React.PropsWithChildren<ChartCardProps>) {
  return (
    <Paper variant="outlined" sx={{ padding: 2 }}>
      <Stack gap={2}>
        <Typography variant="h6">{title}</Typography>

        {children}
      </Stack>
    </Paper>
  );
}
